<template>
  <div>
    <div class="text-right mb-1">
      <b-button
        variant="outline-primary"
        pill
        @click="createSite"
        v-if="hasPermission('create_site')"
      >
        <feather-icon icon="PlusIcon" class="mr-50" />
        <span class="align-middle">Add New</span>
      </b-button>
    </div>

    <b-row class="d-flex justify-content-between m-1">
      <b-col md="" class="rounded mr-1 p-2" style="background-color: white;">
        <b-row class="d-flex align-items-center">
          <b-col md="8">
            <h2 class="py-1 text-dark font-weight-bolder">Total Sites</h2>            
            <b-row>
              <b-col md="8" class="d-flex justify-content-start">
                <h5 class="text-dark font-weight-bolder">Sites</h5>
              </b-col>
              <b-col md="4">
                <h5 class="text-dark font-weight-bold">{{ counts.sites }}</h5>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="8" class="d-flex justify-content-start">
                <h5 class="text-dark font-weight-bolder">Buildings</h5>
              </b-col>
              <b-col md="4">
                <h5 class="text-dark font-weight-bold">{{ counts.buildings }}</h5>
              </b-col>
            </b-row>
          </b-col>
          <b-col md="4">
            <h2 class="py-1 text-dark font-weight-bolder">
              <b-img
                src="@/assets/images/dashboard/site.svg"
                class="img-fluid"
                width="100"
              />
            </h2>
          </b-col>
        </b-row>
      </b-col>

      <b-col md="" class="rounded mr-1 p-2" style="background-color: white;">
        <b-row class="d-flex align-items-center">
          <b-col md="8">
            <h2 class="py-1 text-dark font-weight-bolder">Total Occupants</h2>
            <b-row>
              <b-col md="8" class="d-flex justify-content-start">
                <h5 class="text-dark font-weight-bolder">Residents</h5>
              </b-col>
              <b-col md="4">
                <h5 class="text-dark font-weight-bold">{{ counts.resident }}</h5>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="8" class="d-flex justify-content-start">
                <h5 class="text-dark font-weight-bolder">Contractors</h5>
              </b-col>
              <b-col md="4">
                <h5 class="text-dark font-weight-bold">{{ counts.visitor }}</h5>
              </b-col>
            </b-row>            
          </b-col>
          <b-col md="4">
            <h2 class="py-1 text-dark font-weight-bolder">
              <b-img
                src="@/assets/images/dashboard/resident.svg"
                class="img-fluid"
                width="100"
              />
            </h2>
          </b-col>
        </b-row>
      </b-col>

      <b-col md="" class="rounded mr-1 p-2" style="background-color: white;">
        <b-row class="d-flex align-items-center">
          <b-col md="8">
            <h2 class="py-1 text-dark font-weight-bolder">Total PEEPs</h2>
            <b-row>
              <b-col md="9" class="d-flex justify-content-start">
                <h5 class="text-dark font-weight-bolder">Permanent PEEPs</h5>
              </b-col>
              <b-col md="3">
                <h5 class="text-dark font-weight-bold">{{ counts.perm_peeps_count }}</h5>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="9" class="d-flex justify-content-start">
                <h5 class="text-dark font-weight-bolder">Temporary PEEPs</h5>
              </b-col>
              <b-col md="3">
                <h5 class="text-dark font-weight-bold">{{ counts.temp_peeps_count }}</h5>
              </b-col>
            </b-row>
          </b-col>

          <b-col md="4" class="text-center">
            <h2 class="py-1 text-dark font-weight-bolder">
              <b-img
                src="@/assets/images/dashboard/peep.svg"
                class="img-fluid"
                width="100"
              />
            </h2>
          </b-col>
        </b-row>
      </b-col>
    </b-row>


    <b-card class="mt-3">
      <b-row class="mb-1" align-v="center">
        <b-col md="7">
          <div v-if="searchType">
            <b-form-group
              label="Name"
              label-for="name"
              class="w-50"
              v-if="searchType.value === 1"
            >
              <b-input-group>
                <template #prepend> </template>
              </b-input-group>
              <b-form-input
                id="name"
                v-model="name"
                placeholder="Name"
                type="text"
                required
              />
            </b-form-group>

            <b-form-group
              label="Post Code"
              label-for="postcode"
              class="w-50"
              v-if="searchType.value === 2"
            >
              <b-input-group>
                <template #prepend> </template>
              </b-input-group>
              <b-form-input
                id="postcode"
                v-model="postcode"
                placeholder="Post Code"
                type="text"
                required
              />
            </b-form-group>
          </div>
        </b-col>
        <b-col md="3">
          <b-form-group label="Search Type" label-for="searchType">
            <v-select
              id="searchType"
              v-model="searchType"
              :options="searchTypes"
              placeholder="Search Type"
              label="name"
            />
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-button variant="primary" pill @click="search">
            <feather-icon icon="SearchIcon" class="mr-50" />
            <span class="align-middle">Search</span>
          </b-button>
        </b-col>
      </b-row>
      <b-table
        responsive="sm"
        :fields="fields"
        :items="sites"
        details-td-class="m-1 p-1"
        small
        v-if="hasPermission('read_site')"
        :per-page="0"
      >
        <template #cell(name)="row">
          <b-link @click="row.toggleDetails">
            {{
              row.item.name ? row.item.name : ""
            }}
          </b-link>
        </template>

        <template #row-details="row">
          <b-card bg-variant="light" border-variant="dark">
            <b-table
              responsive="sm"
              :fields="buildingfields"
              :items="row.item.buildings_data"
              details-td-class="m-0 p-0"
              small
            >
            </b-table>
          </b-card>
        </template>
        
        <template #cell(manage)="row">
          <b-button
            variant="success"
            pill
            size="sm"
            class="mr-50"
            @click="editSite(row.item)"
            v-if="hasPermission('update_site')"
          >
            Edit
          </b-button>
        </template>
      </b-table>
      <div class="row">
        <div class="col-md-11">
          <b-pagination
            size="md"
            :total-rows="totalItems"
            v-model="currentPage"
            :per-page="perPage"
          ></b-pagination>
        </div>
        <div class="col-md-1">
          <h4>
          Total: {{ totalItems }} 
          </h4>
        </div>
      </div>
    </b-card>
    <CreateSiteModal
      @modalClosed="onModalClosed"
      :key="`create-${createSiteModalCount}`"
    />
    <EditSiteModal
      :site="site"
      @modalClosed="onModalClosed"
      :key="`edit-${editSiteModalCount}`"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import VueSelectPaginated from "@/components/ui/VueSelectPaginated.vue";
import CreateSiteModal from "@/components/site/CreateSiteModal.vue";
import EditSiteModal from "@/components/site/EditSiteModal.vue";
import util from "@/util.js";
import VueGauge from 'vue-gauge';
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";



export default {
  components: {
    CreateSiteModal,
    EditSiteModal,
    VueSelectPaginated,
    VueGauge,
  },
  data() {
    return {
      fields: [
        { key: "name", label: "Name" },
        { key: "total_staff", label: "Staff" },
        { key: "trained_staff", label: "Trained Staff" },
        { key: "postcode", label: "Postcode" },
        { key: "total_residents_count", label: "Residents" },
        { key: "total_peeps_count", label: "Total Peeps" },
        { key: "postcode", label: "postcode" },
        { key: "manage", label: "Actions" },
      ],
      buildingfields: [
        { key: "name", label: "Building Name" },
        { key: "building_type", label: "Building Type" },
        { key: "total_flats_count", label: "Total Flats" },
        { key: "total_floors_count", label: "Total Floors" },
        { key: "total_residents_count", label: "Total Residents" },
        { key: "total_peeps_count", label: "Total Peeps" },
      ],
      currentPage: 1,
      perPage: 0,
      totalItems: 0,
      sites: [],
      site: null,
      createSiteModalCount: 0,
      editSiteModalCount: 0,
      searchTypes: [
        { value: 1, name: "Name" },
        { value: 2, name: "postcode" },
      ],
      searchType: null,
      name: "",
      counts : "",
      states : [],
      citys: [],
      sub_states: [],
      state : "",
      city : "",
      sub_state : "",
      name: "",
    };
  },
  mixins: [util],
  created() {
  },
  async mounted() {    
    this.searchType = this.searchTypes[0];

    await this.fetchPaginatedData();
    const counter = await this.getCounter();
    this.counts = counter.data;
  },
  methods: {
    ...mapActions({
      getCounter: "appData/getCounter",
      getSites: "appData/getSites",
    }),
    async search() {
      if (this.searchType) {
        switch (this.searchType.value) {
          case 1:
            this.postcode = "";
            break;
          case 2:
            this.name = "";
            break;
          
        }
      } else {
        this.name = "";
        this.postcode = "";
      }
      this.currentPage = 1;
      await this.fetchPaginatedData();
    },
    async fetchPaginatedData() {
      try {
        const res = await this.getSites({
          pageNumber: this.currentPage,      
          name: this.name,      
          postcode: this.postcode,      
        });
        this.sites = res.data.results;
        this.totalItems = res.data.count;
        this.perPage = res.data.per_page;
      } catch (error) {
        this.displayError(error);
      }
    },
    createSite() {      
      this.createSiteModalCount += 1;
      this.$nextTick(() => {
        this.$bvModal.show("create-site-modal");
      });
    },
    editSite(site) {
      this.site = site;
      this.editSiteModalCount += 1;
      this.$nextTick(() => {
        this.$bvModal.show("edit-site-modal");
      });
    },
    async removeSite(site) {
      this.site = site;
      try {
        const res = await this.deleteSite({
          pk: this.site.id,
        });
        if (res.status === 204) {
          this.$swal({
            title: "Site deleted successfully",
            icon: "success",
          });
          if (
            (this.totalItems - 1) % this.perPage === 0 &&
            this.currentPage !== 1
          ) {
            this.currentPage -= 1;
          } else {
            await this.fetchPaginatedData();
          }
        }
      } catch (error) {
        this.displayError(error);
      }
    },
    async onModalClosed() {
      await this.fetchPaginatedData();
    },
  },
  computed: {
    ...mapGetters({
      hasPermission: "appData/hasPermission", getLoggedInUser: "appData/getLoggedInUser"
    }),
  },
  watch: {
    currentPage: async function (val) {
      await this.fetchPaginatedData();
    },
  },
  
};
</script>

<style></style>
